import color from '@/core/features/styles/color';

export type RadioButtonProps = {
    hasHoverEffect?: boolean;
    isDisabled?: boolean;
    isSelected: boolean;
};

export default function RadioButton({ hasHoverEffect = false, isDisabled, isSelected }: RadioButtonProps) {
    const isHovered = hasHoverEffect && !isDisabled;
    return (
        <span className={'inline-block'}>
            <span className={`flex items-center justify-center circle ${isHovered ? 'circleHover' : ''}`}>
                {isSelected && <span className={'dot'} />}
            </span>
            <style jsx>{`
                .circle {
                    border: 1px solid;
                    border-color: ${isDisabled ? color('alto') : isSelected ? color('endeavour') : color('nobel')};
                    border-radius: 50%;
                    height: 22px;
                    width: 22px;
                    margin-bottom: 1px;
                }
                .circleHover:hover {
                    border-color: ${color('endeavour')};
                }
                .dot {
                    background-color: ${isDisabled ? color('alto') : isSelected ? color('endeavour') : 'transparent'};
                    border-radius: 50%;
                    height: 10px;
                    width: 10px;
                }
            `}</style>
        </span>
    );
}
